<template>
  <div class="circle-indicator d-flex mx-1" :class="{ 'active': active, 'inactive': !active }">
    <span class="my-auto mx-auto">{{ number }}</span>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    number: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-indicator {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 20px;
}

.inactive {
  background-color: #dddddd;
  color: #939393;
}

.active {
  background-color: #BA7C40;
  color: white;
}

.inactive-done {
  background-color: #41af1a;
  color: #fff;
}
</style>